import React from "react";
import styled from "styled-components";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";
import { hexToRGBA } from "../../../../../utils/theme";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

const StyledContainer = styled.div`
  margin-bottom: 24px;
  border: 1px solid ${hexToRGBA('#000000', 0.1)};
  border-radius: 0.25rem;

  label[for='legalName'] {
    width: 100%;
  }
`;

const StyledRow = styled(Row)`
  padding: 16px;
`;

function PrincipalOfficerInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>Principal Officer Information</span>
      </div>
      <StyledRow>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerFirstName)}
            label={getFieldProps(FORM_FIELD_KEYS.principalOfficerFirstName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.principalOfficerFirstName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerMiddleName)}
            label={getFieldProps(FORM_FIELD_KEYS.principalOfficerMiddleName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.principalOfficerMiddleName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerLastName)}
            label={getFieldProps(FORM_FIELD_KEYS.principalOfficerLastName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.principalOfficerLastName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerTitle)}
            label={getFieldProps(FORM_FIELD_KEYS.principalOfficerTitle)?.placeholder?.replace("*", "")}
            placeholder={getFieldProps(FORM_FIELD_KEYS.principalOfficerTitle)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.principalOfficerTitle]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerSuffixName)}
            label={getFieldProps(FORM_FIELD_KEYS.principalOfficerSuffixName)?.placeholder?.replace("*", "")}
            placeholder={getFieldProps(FORM_FIELD_KEYS.principalOfficerSuffixName)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.principalOfficerSuffixName]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <MaskInput
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerSSN)}
            label="Social Security Number"
            placeholder={getFieldProps(FORM_FIELD_KEYS.principalOfficerSSN)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.principalOfficerSSN]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
      </StyledRow>
    </StyledContainer>
  );
}

export default PrincipalOfficerInfoBlock;
